module.exports = __webpack_public_path__ + "static/media/296190.913fc0f2.png";